module.exports = function() {
    const   playBanner = document.querySelector('.banner-top__video-play'),
            video = document.querySelector('.single .banner-top__video');

    if( video ) {
        playBanner.addEventListener('click', function(){
            this.classList.add('is-hide');
    
            video.play();
        });
    
        video.addEventListener('timeupdate', function(){
            playBanner.classList.add('is-hide');
        });
    
        video.onpause = function() {
            playBanner.classList.remove('is-hide');
        }
    }

};